import { useState } from 'react';
import BottomNav from '../base/BottomNav';
import PublicMoreSheet from './PublicMoreSheet';
import AssistantChatPanel from '../assistant/AssistantChatPanel';

const navItems = [
  { to: '/', label: 'Home', icon: 'ri-home-5-line', exact: true },
  { to: '/paquetes', label: 'Packages', icon: 'ri-stack-line', exact: false },
  { to: '/muestras/fotos', label: 'Gallery', icon: 'ri-image-line', exact: false },
  { to: '/precios', label: 'Prices', icon: 'ri-price-tag-3-line', exact: false },
];

export default function PublicBottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const [assistantOpen, setAssistantOpen] = useState(false);

  return (
    <>
      <BottomNav
        items={navItems}
        moreButton={{
          label: 'More',
          icon: 'ri-apps-line',
          onClick: () => setMoreOpen(true),
          active: moreOpen,
        }}
      />
      <PublicMoreSheet
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        onAssistantClick={() => {
          setMoreOpen(false);
          setAssistantOpen(true);
        }}
      />
      <AssistantChatPanel
        isOpen={assistantOpen}
        onClose={() => setAssistantOpen(false)}
      />
    </>
  );
}